import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { inferMediaType } from '../../../controls/media/mediaLogic';

// Счётчик медиа вопроса по типам (тип — из расширения mediaFileUrl, бэк его не шлёт).
function mediaCounts(media) {
    const counts = { IMAGE: 0, AUDIO: 0, VIDEO: 0 };
    (Array.isArray(media) ? media : []).forEach(m => {
        const t = m.fileExtensionType || inferMediaType(m);
        if (counts[t] != null) counts[t] += 1;
    });
    return counts;
}

// Колонка «Вопросы»: список вопросов текущего раунда с выбором.
export default function QuestionsColumn({ rounds, session, dispatch }) {
    const parentRef = useRef(null);
    const currentRoundOrderId = session.currentRound?.orderId;
    const currentQuestionId = session.currentQuestion?.id;

    useEffect(() => {
        const container = parentRef.current;
        if (!currentQuestionId || !container) return;
        const el = container.querySelector(`[data-qid="${currentQuestionId}"]`);
        if (!el) return;
        // Скроллим контейнер так, чтобы активный вопрос встал к верху видимой зоны
        // (через rect — не зависит от offsetParent, в отличие от offsetTop).
        const delta = el.getBoundingClientRect().top - container.getBoundingClientRect().top;
        container.scrollTo({ top: container.scrollTop + delta - 12, behavior: 'smooth' });
    }, [currentQuestionId]);

    const round = rounds.find(r => r.orderId === currentRoundOrderId);
    const questions = [...(round?.questions || [])].sort((a, b) => a.orderId - b.orderId);

    return (
        <div className="ctrl-col" ref={parentRef}>
            <h4>Список</h4>
            <div className="qlist">
                {questions.map(question => {
                    const counts = mediaCounts(question.media);
                    const hasTags = counts.IMAGE > 0 || counts.AUDIO > 0 || counts.VIDEO > 0;
                    return (
                        <button
                            type="button"
                            key={question.id}
                            data-qid={question.id}
                            className={`qrow${question.id === currentQuestionId ? ' active' : ''}`}
                            onClick={() => dispatch.selectQuestion(question.orderId)}
                        >
                            <span className="qrow-q">{question.questionText}</span>
                            {hasTags && (
                                <span className="qrow-tags">
                                    {counts.IMAGE > 0 && <span className="qtag t-img">Фото - {counts.IMAGE}</span>}
                                    {counts.AUDIO > 0 && <span className="qtag t-aud">Аудио - {counts.AUDIO}</span>}
                                    {counts.VIDEO > 0 && <span className="qtag t-vid">Видео - {counts.VIDEO}</span>}
                                </span>
                            )}
                            <span className="on">{question.orderId}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

QuestionsColumn.propTypes = {
    rounds: PropTypes.array.isRequired,
    session: PropTypes.object.isRequired,
    dispatch: PropTypes.object.isRequired
};
